module.exports = require("@scure/bip39");